// The appointments API reads `assignees` as PracticeUser objects but only
// accepts primary keys on write ("Incorrect type. Expected pk value, received
// dict."). Accepts ids (number|numeric string) or objects carrying `id`, and
// always returns a de-duplicated number[]. Non-array input returns [].
export function toAssigneeIds(list) {
    if (!Array.isArray(list)) return [];
    const seen = new Set();
    const out = [];
    list.forEach((item) => {
        const raw = item !== null && typeof item === 'object' ? item.id : item;
        let id;
        if (typeof raw === 'number') id = raw;
        else if (typeof raw === 'string' && /^\d+$/.test(raw.trim())) id = Number(raw.trim());
        else return; // booleans, blanks, non-numeric strings, null/undefined
        if (!Number.isInteger(id) || seen.has(id)) return;
        seen.add(id);
        out.push(id);
    });
    return out;
}

// `assignees: null` is passed through untouched (never coerced to [] which
// could clear all assignees); only arrays are normalised.
// Returns a copy of `payload` whose `assignees` (when present) is number[].
export function withAssigneeIds(payload) {
    if (!payload || typeof payload !== 'object' || !('assignees' in payload) || payload.assignees === undefined || !Array.isArray(payload.assignees)) return payload;
    return { ...payload, assignees: toAssigneeIds(payload.assignees) };
}

export default toAssigneeIds;
